import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class ConditionReportSearchModel extends BaseModel {
  version = null;
  title = null;
  internal_note = null;
  status = null;
  released_by_uuid = null;

  rules = {};

  attributeLabels = {
    version: i18n.t('Version'),
    title: i18n.t('Title'),
    internal_note: i18n.t('Internal Note'),
    status: i18n.t('Status'),
    released_by_uuid: i18n.t('Released By'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    delete data.released_by;
    return data;
  }
}
